export default "__VITE_ASSET__zVRrbPmh__"